import React, { Suspense, lazy } from 'react'
import { Redirect } from 'react-router-dom';
import SecurityLayout from '@/layouts/SecurityLayout'

const suspenseComponent = Component => props => (
  <Suspense fallback={<div></div>}>
    <Component {...props}/>
  </Suspense>
)

export default [
  // {
  //   path: '/login',
  //   component: suspenseComponent(lazy(() => import('@/pages/User/Login')))
  // },
  {
    path: '/',
    component: SecurityLayout,
    routes: [
      {
        path: '/',
        exact: true,
        render: () => <Redirect to="/no-pub" />,
      },
      {
        path: '/no-pub',
        component: suspenseComponent(lazy(() => import('@/pages/NoPub')))
      },
      {
        path: '/capital',
        component: suspenseComponent(lazy(() => import('@/pages/CapitalDown')))
      },
      {
        path: '/capitalweb',
        component: suspenseComponent(lazy(() => import('@/pages/WebCaitalDown')))
      },

      {
        path: '/m',
        component: suspenseComponent(lazy(() => import('@/pages/Down')))
      },
      {
        path: '/mms',
        component: suspenseComponent(lazy(() => import('@/pages/Down')))
      },
      {
        path: '/g/',
        component: suspenseComponent(lazy(() => import('@/pages/Guide')))
      },
      {
        path: '/web',
        component: suspenseComponent(lazy(() => import('@/pages/DownWeb')))
      },
      {
        path: '/home',
        component: suspenseComponent(lazy(() => import('@/pages/Home')))
      },
      {
        path: '/provacyDoctorPage',
        component: suspenseComponent(lazy(() => import('@/pages/ProvacyDoctorPage')))
      },
      {
        path: '/provacyPage',
        component: suspenseComponent(lazy(() => import('@/pages/ProvacyPage')))
      },
      // {
      //   path: '/news',
      //   component: suspenseComponent(lazy(() => import('@/pages/News')))
      // },
      // {
      //   path: '/recommend',
      //   component: suspenseComponent(lazy(() => import('@/pages/Recommend')))
      // },
      {
        component: suspenseComponent(lazy(() => import('@/pages/404')))
      },
    ]
  },
]
